import { Swiper, Navigation, Autoplay } from "swiper/bundle";
export default class SwipeQuote {
    constructor() {
        console.log('%c👍🏼 Swiper Quote', 'color: yellow');
        
        this.swiperQuote = document.querySelectorAll(
            '.swiper--quote'
        )
    }
    init() {
        this.swiperQuote.forEach((elem, i) => {
            
            new Swiper(elem, {
                slidesPerView: 1.2,
                loop: true,
                spaceBetween: 20,
                speed: 1001,
                direction: 'horizontal',
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true
                },
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        direction: 'vertical',
                        slidesPerView: 3,
                    }
                }
            });                   
        })
    }
}

